var modHeader = function(){
    var scope = ".js-mod-header";
    ui.ready(
        scope,
        function($mod){
            function checkScroll($mod){
                var scroll = $(window).scrollTop();
                $mod.toggleClass("is-fixed",scroll>=1)
            }

            $(window).scroll(
                function(){
                checkScroll($mod);
            });
            checkScroll($mod);

            $mod.find(scope+"__opener").click(
                function(ev){
                    ev.preventDefault();
                    ev.stopPropagation();
                    $mod.find(scope+"__mobile-menu").toggleClass('is-opened');
                    $mod.find(scope+"__main-menu").toggleClass('main-menu__is-opened');
                    /*$('body').toggleClass('u-no-scroll');*/
                }
            );

            $mod.find(scope+"__logout").click(
                function(ev){
                    ev.preventDefault();
                    gvf.endpoint(
                        "web\\loginController::logout",
                        [],
                        function(response){
                            if(response.status=="ok"){
                                window.location = response.url;
                            }
                        }
                    );
                }
            );


/*            var $contact = $mod.find(scope+"__mail-contact");
            var email = $contact.data("email").replace(/-sep-/g,"@");
            $contact.append(email);
            $contact.attr("href","mailto:"+email);*/

            $("body").on(
                "web:cartQuantityUpdate",
                function(ev,data){
                    $mod.find(scope+"__cart-quantity").html(data.unit_count);
                    if(data.message){
                        $mod.find(scope+"__cart-alert-message").html(data.message);
                        $mod.addClass("is-showing-cart-alert");
                        gvf.delay(
                            5000,
                            function(){
                                $mod.removeClass("is-showing-cart-alert")
                            }
                        );
                    }

                    if(window.gtag && data.previous_quantity<data.quantity){
                        gtag('event', 'add_to_cart', {
                            currency: 'EUR',
                            items: [{
                                id: data.product.code,
                                name: data.product.name,
                                category: data.product.category,
                                price: data.product.price,
                                quantity: data.quantity
                            }],
                            value: data.product.price
                        });
                        fbq('track', 'AddToCart', {
                            content_name: data.product.name,
                            content_category: data.product.category,
                            content_ids: [data.product.code],
                            content_type: 'product',
                            value: data.product.price,
                            currency: 'EUR'
                        });
                    }
                }
            );

            $mod.find(scope+"__main-menu-item-chevronmobile").click(
                function(ev){
                    ev.preventDefault();
                    ev.stopPropagation();

                    if($(this).next().css('display') === 'none'){
                        $(this).next().show();
                        $(this).find("span").removeClass("fas fa-chevron-up");
                        $(this).find("span").addClass("fas fa-chevron-down");
                    }else{
                        $(this).next().hide();
                        $(this).find("span").removeClass("fas fa-chevron-down");
                        $(this).find("span").addClass("fas fa-chevron-up");
                    }
                }
            );

            new Swiper($mod.find(scope + '__slider').get(0), {
                // AutoPlay
                autoplay: {
                    delay: 3000,
                    pauseOnMouseEnter: true,
                },
                speed: 1000,
                spaceBetween: 0,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                // Loop
                loop: true,
                slidesPerView:'auto',
                allowTouchMove: true,
                disableOnInteraction: true
            });
        }
    );
}();
